import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import TarifarioMaritimoContext from '../../../../../contexts/pricing/tarifario/TarifarioMaritimoContext';
import {
  selectBackgroundMode,
  selectMode,
  selectStatus,
  selectSubMode,
} from '../../../../../features/tarifario/tarifarioSelectors';
import QCXPageTemplate from '../../../../../templates/page/QCXPageTemplate';
import { isLoadingStatus } from '../../../../../utils/store/store-utils';

export default function TarifarioMaritimoPage({ children }) {
  const status = useSelector(selectStatus);

  const modeSelectors = useMemo(
    () => ({
      selectMode,
      selectSubMode,
      selectBackgroundMode,
    }),
    [selectMode, selectSubMode, selectBackgroundMode]
  );

  const isLoading = useMemo(() => isLoadingStatus(status), [status]);

  const providerData = useMemo(
    () => ({
      status,
      isLoading,
    }),
    [status, isLoading]
  );

  return (
    <TarifarioMaritimoContext.Provider value={providerData}>
      <QCXPageTemplate contextComponent={TarifarioMaritimoContext} modeSelectors={modeSelectors}>
        {children}
      </QCXPageTemplate>
    </TarifarioMaritimoContext.Provider>
  );
}
